import { Injectable } from '@angular/core';
import {  Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service'

const baseUrl = environment.hostService + '/ConfigData';

@Injectable({
  providedIn: 'root'
})

export class ConfigDataService {

  constructor(private _http: HttpClientService) { }

  getComboSedes(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetComboSedes', cacheMins: 5 })
  }
  getDatosPersonales(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosInfoDatosPersonales', cacheMins: 5 })
  }
  GetCombosInfoDatosOrganizativos(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosInfoDatosOrganizativos', cacheMins: 5 })
  }
  getDatosDirecciones(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosInfoDirecciones', cacheMins: 5 })
  }
  getDatosFamiliares(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosInfoFamiliares', cacheMins: 5 })
  }
  getDatosInfoIdentidad(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosInfoIdentidad', cacheMins: 5 })
  }
  getDatosFechas(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetComboDatosFechas', cacheMins: 5 })
  }
  getComboContratos(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetComboContratos', cacheMins: 5 })
  }
  GetBancos(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosInfoDatosBancarios', cacheMins: 5 })
  }
  getSueldos(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosInfoSueldoBasico', cacheMins: 5 })
  }
  getDatosAfiliaciones(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetComboClaseAfiliaciones', cacheMins: 5 })
  }
  getDatosNominas(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosNovedades', cacheMins: 5 })
  }
  getDatosDeducciones(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosDeducciones', cacheMins: 5 })
  }
  GetSeguridadSocial(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosSeguridadSocial', cacheMins: 5 })
  }
  getDatosIndemnizaciones(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosIndemnizaciones', cacheMins: 5 })
  }
  getDatosContingentes(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosContingentes', cacheMins: 5 })
  }
  getDatosAusentismos(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetCombosAusentismos', cacheMins: 5 })
  }
  
  
}
